import colorEn from "./en/color.json";
import glossaryEn from "./en/glossary.json";
import spacingEn from "./en/spacing.json";
import typographyEn from "./en/typography.json";
import colorTr from "./tr/color.json";
import glossaryTr from "./tr/glossary.json";
import spacingTr from "./tr/spacing.json";
import typographyTr from "./tr/typography.json";

export const FOUNDATION_DICTIONARIES: Record<"tr" | "en", Record<string, string>> = {
    en: {
        ...colorEn,
        ...glossaryEn,
        ...spacingEn,
        ...typographyEn
    },
    tr: {
        ...colorTr,
        ...glossaryTr,
        ...spacingTr,
        ...typographyTr
    }
};
